import { render, staticRenderFns } from "./ProductPropertyAdd.vue?vue&type=template&id=55d35418&"
import script from "./ProductPropertyAdd.vue?vue&type=script&lang=js&"
export * from "./ProductPropertyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports